import React from 'react';
import { Box, Button, Paragraph } from 'bumbag';
import _get from 'lodash/get';

import LandingPage from '@medipass/react-core/Layout/LandingPage';
import { Link as RouterLink, withRouter } from '@medipass/react-core/router';
import sdk from '@medipass/web-sdk';

import MedicareAccountForm from 'components/account/health-fund-accounts/MedicareAccountForm';
import WithAuthentication from 'components/WithAuthentication';
import { updateMembersHealthFundAccount } from 'utils/health-fund-accounts';
type Props = {
  history: (...args: Array<any>) => any;
};

class CreateMedicareAccount extends React.PureComponent<Props> {
  handleAddMedicareAccount = async (medicareAccount: Record<string, any>) => {
    const { history } = this.props;

    const memberId = _get(sdk, 'member._id');

    const body = await updateMembersHealthFundAccount({
      healthFundAccount: medicareAccount,
      memberId,
    });
    // @ts-expect-error TS(2339): Property 'push' does not exist on type '(...args: ... Remove this comment to see the full error message
    history.push('/');
    return body;
  };
  handleClickCancel = () => {
    window.history.back();
  };
  render = () => (
    <WithAuthentication>
      <LandingPage
        description={
          <Paragraph>Add your Medicare card to enable us to instantly process any benefits owing to you.</Paragraph>
        }
        // @ts-expect-error
        isLight
        title="Add Medicare card"
      >
        <MedicareAccountForm
          isMobileTitle={false}
          isSubmitButtonInsideSection
          onSubmit={this.handleAddMedicareAccount}
          submitButtonRenderer={({ isLoading }) => (
            <Box textAlign="center">
              <Button palette="secondary" isLoading={isLoading} size="medium" width="100%" type="submit">
                CONTINUE
              </Button>
              <Button
                // @ts-expect-error
                use={RouterLink}
                to="/account/transactions/"
                palette="primary"
                marginTop="major-1"
                variant="ghost"
              >
                I{"'"}ll do this later
              </Button>
            </Box>
          )}
          title="Add your Medicare card"
        />
      </LandingPage>
    </WithAuthentication>
  );
}

export default withRouter(CreateMedicareAccount);
